import { createGlobalStyle } from 'styled-components';
import tw, { css, theme } from 'twin.macro';

const inputBaseStyles = css`
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill:focus {
    -webkit-text-fill-color: ${theme`colors.input-focus-text-color`};
    background-color: transparent;
  }

  input:-webkit-autofill,
  textarea:-webkit-autofill,
  select:-webkit-autofill,
  input:-webkit-autofill:hover,
  textarea:-webkit-autofill:hover,
  select:-webkit-autofill:hover {
    -webkit-text-fill-color: ${theme`colors.input-focus-text-color`};
    background-color: transparent;
  }
`;

const AccountStyle = createGlobalStyle(
  {
    body: tw`bg-page-background`,
    h3: tw`text-base text-text-and-icon-muted font-semibold text-center`,
    p: tw`text-xs text-text-and-icon-muted text-center`,
    a: tw`text-accent-2 underline`,
  },
  inputBaseStyles
);

export default AccountStyle;
